import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const nepImages = [
    "1000309318.jpg",
    "1000309271.jpg",
    "1000309277.jpg",
    "1000309312.jpg",
];

function NEP2020QualityAssurance() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className="pb-2">
                                        The Challenges and Impact of NEP-2020 for Higher Education in Quality Assurance
                                    </h2>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">
                                        <div className="row">
                                            {nepImages.map((file, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/nep-2020-quality-assurance/${file}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/nep-2020-quality-assurance/${file}`}
                                                            loading="lazy"
                                                            alt={`NEP-2020 Quality Assurance - Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default NEP2020QualityAssurance;
